 
 
const state = {
	activeRoutes: [{
		name: '应用软件',
		path: '/company',
		isAct: 1
	}]
}
 
const mutations = {
	SET_ROUTES: (state, routes) => {
		state.addRoutes = routes
		state.routes = constantRoutes.concat(routes)
 
	},
 
	ADD_ROUTE(state, route) {
		const existingRoute = state.activeRoutes.find(r => r.name === route.name);
		if (!existingRoute) {
			// 如果路由不存在，检查是否为 'dashboard'  
			if (route.name === 'company') {
				route.name = '应用软件'; // 修改路由名称为 '首页'  
			}
			route.isAct = 1; // 设置活跃状态  
			state.activeRoutes.push(route); // 添加路由  
		} else {
			// 如果路由已存在，更新活跃状态  
			existingRoute.isAct = 1; // 更新活跃状态  
		}
		// 将其他不活跃的路由状态设置为 2  
		state.activeRoutes.forEach(r => {
			if (r.name !== route.name) {
				r.isAct = 2; // 设置不活跃状态为 2  
			}
		});
 
	},
	REMOVE_ROUTE(state, routeName) {
		// 移除指定的路由  
		state.activeRoutes = state.activeRoutes.filter(route => route.name !== routeName);
	},
}
 
const actions = {
	addRoute({ commit }, route) {
		commit('ADD_ROUTE', route);
	},
	removeRoute({ commit }, routeName) {
		commit('REMOVE_ROUTE', routeName);
	},
 
	
}
 
export default {
	namespaced: true,
	state,
	mutations,
	actions
}